import { createReducer } from '@reduxjs/toolkit'
import { TradeType } from 'store/market/types'
import {
  updateConnectorName,
  updatePlaceOrderTIFAction,
  updatePreference,
  updatePreferences,
  updateSaveToken,
  updateShowMandatoryToast,
  updateShowPortfolio,
  updateTheme,
  updateFavoriteAssetsElements,
} from 'store/settings/actions'
import {
  SettingState,
  TifType,
  EFavoriteAssetsElements,
} from 'store/settings/types'
import { MuiThemeType } from 'styles/Themes'

export const defaultTif = {
  [TradeType.Spot]: TifType.GTC,
  [TradeType.Perp]: TifType.GTC,
  [TradeType.None]: TifType.GTC,
}

export const initialState: SettingState = {
  theme: MuiThemeType.dark,
  connectorName: undefined,
  showPortfolio: true,
  save: false,
  mandatoryToast: {
    id: 0,
    expirationTime: 0,
    content: '',
    createdAt: 0,
    notifyType: 1,
    title: '',
  },
  tif: defaultTif,
  preferences: {
    orderConfirmation: true,
    fundChange: true,
  },
  favoriteAssetsElements: [EFavoriteAssetsElements.Balance],
}

export default createReducer<SettingState>(initialState, (builder) => {
  builder
    .addCase(updateTheme, (state, { payload }) => {
      state.theme = payload
    })
    .addCase(updateConnectorName, (state, { payload }) => {
      state.connectorName = payload.connectorName
    })
    .addCase(updateShowPortfolio, (state, { payload }) => {
      state.showPortfolio = payload
    })
    .addCase(updateSaveToken, (state, { payload }) => {
      state.save = payload
    })
    .addCase(updateShowMandatoryToast, (state, { payload }) => {
      state.mandatoryToast = { ...payload }
    })
    .addCase(updatePlaceOrderTIFAction, (state, { payload }) => {
      const { tradeType, tif } = payload
      if (!state.tif) {
        state.tif = defaultTif
      }
      state.tif = { ...state.tif, [tradeType]: tif }
    })
    .addCase(updatePreferences, (state, { payload }) => {
      state.preferences = payload
    })
    .addCase(updatePreference, (state, { payload }) => {
      state.preferences[payload.type] = payload.value
    })
    .addCase(updateFavoriteAssetsElements, (state, { payload }) => {
      if (payload.type === 'del' && state.favoriteAssetsElements.length !== 0) {
        state.favoriteAssetsElements = state.favoriteAssetsElements.filter(
          (item) => item !== payload.value,
        )
      }
      if (payload.type === 'add' && state.favoriteAssetsElements.length !== 3) {
        state.favoriteAssetsElements = [
          ...state.favoriteAssetsElements,
          payload.value,
        ]
      }
    })
})
